// CountdownTimer.js - 3-2-1 countdown with animations
import React, { useState, useEffect } from 'react';

export function CountdownTimer({ onComplete, duration = 3 }) {
  const [count, setCount] = useState(duration);
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (!isActive) return;

    if (count === 0) {
      onComplete?.();
      return;
    }

    const timer = setTimeout(() => {
      setCount(prev => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [count, isActive, onComplete]);

  if (count === 0) return null;

  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black/50 backdrop-blur-sm z-20">
      <div
        key={count} // Key change triggers re-animation
        className="animate-countdown-scale"
      >
        <span
          className="text-[120px] md:text-[180px] font-bold text-white drop-shadow-2xl"
          style={{
            fontFamily: 'Barlow Condensed, sans-serif',
            textShadow: '0 0 60px rgba(139, 21, 56, 0.8)' // Maroon glow
          }}
        >
          {count}
        </span>
      </div>
    </div>
  );
}

export default CountdownTimer;
